/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 08.06.25
 *
 */

import Discriminator from "@/utils/Discriminator";
import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {
	FormJournalEntry,
	GroupJournalEntry,
	LegalDocJournalEntry,
	NoteJournalEntry,
	ReminderJournalEntry,
	SessionJournalEntry,
	TaskJournalEntry,
	SessionPlanJournalEntry,
	TLSWSessionPlanJournalEntry,
	BTSessionPlanJournalEntry
} from "@shared/Journal/journalEntry-imports";


let JournalEntryDiscriminator = Discriminator.create([
	{ value: () => NoteJournalEntry, name: JournalEntryType.NOTE },
	{ value: () => NoteJournalEntry, name: JournalEntryType.FILE },
	{ value: () => TaskJournalEntry, name: JournalEntryType.TASK },
	{ value: () => FormJournalEntry, name: JournalEntryType.FORM },
	{ value: () => LegalDocJournalEntry, name: JournalEntryType.LEGAL_DOC },
	{ value: () => ReminderJournalEntry, name: JournalEntryType.REMINDER },
	{ value: () => GroupJournalEntry, name: JournalEntryType.GROUP },
	{ value: () => SessionJournalEntry, name: JournalEntryType.SESSION },
	{ value: () => SessionPlanJournalEntry, name: JournalEntryType.SESSION_PLAN },
	{ value: () => TLSWSessionPlanJournalEntry, name: JournalEntryType.TLSW_SESSION_PLAN },
	{ value: () => BTSessionPlanJournalEntry, name: JournalEntryType.BEHAVIOUR_TREE_SESSION_PLAN },


])


export {
	JournalEntryDiscriminator,
}
